import { ApiService } from '@stores/ApiService';
import { apiResponse } from '@stores/index';

export class PhoneValidationStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  async sendCode(phoneNumber: string) {
    try {
      const response = await this.api.post('/user/phone-validation/send-code', { phoneNumber });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  async validateCode(phoneNumber: string, code: string) {
    try {
      const response = await this.api.post('/user/phone-validation/verify-code', { phoneNumber, code });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
